import { Checkbox, Flex, Form } from "antd";
import React from "react";
import { ActionTypeName } from "src/pages/ManagementPage/Obj2Tab/roles/roleTypes";
import styles from "./RoleActionFields.module.less";
import { makeActionOptions, roleActionFieldsMap } from "../roleObjFieldOptions";
import { ZRoleFields } from "../../../RolesTab.types";

const fieldKey = (key: keyof ZRoleFields) => key;

export const RoleActionFields: React.FC = () => (
  <Form.Item className={styles.container} name={fieldKey("defaultPermissions")}>
    {Object.values(ActionTypeName).map((type, index) => {
      const { title, label } = roleActionFieldsMap[type];
      const name = [fieldKey("defaultPermissions"), index];
      return (
        <Flex vertical gap={4} key={name.join("-")}>
          <div className={styles.title}>{title}</div>
          <Form.Item name={name} valuePropName="checked" label={label}>
            <Checkbox.Group
              options={makeActionOptions(type)}
              className={styles.checkboxGroup}
            />
          </Form.Item>
        </Flex>
      );
    })}
  </Form.Item>
);
